import { SectionScoreCard } from "../SectionScoreCard";

import { InstructorAssessmentView } from "./InstructorAssessmentView";
import { StudentAssessmentView } from "./StudentAssessmentView";

import { useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import { selectCurrentSection, selectCurrentUserId } from "store/selectors";

export const SectionAssessmentMainView = () => {
  const currentUserId = useAppSelector(selectCurrentUserId);
  const section = useAppSelector(selectCurrentSection);
  const sectionScoreEnabled = section?.section_score_enabled;
  const { canParticipateInSection, canAuthorSection } = useCapabilities();

  if (sectionScoreEnabled === undefined || !currentUserId) {
    return null;
  }

  return (
    <div className="flex flex-col gap-6 text-xs">
      {canParticipateInSection ? (
        <StudentAssessmentView sectionScoreEnabled={sectionScoreEnabled} userId={currentUserId} />
      ) : canAuthorSection ? (
        <InstructorAssessmentView sectionScoreEnabled={sectionScoreEnabled} />
      ) : sectionScoreEnabled ? (
        <SectionScoreCard />
      ) : null}
    </div>
  );
};
